export const adyenCancelAutoRescueResponse = {
  ERROR: 'Não foi possível efetuar o cancelamento de auto rescue',
};
